'use strict';

import React from 'react';
import ClassNameMixin from '../mixins/ClassNameMixin';
import ZineCover from '../molecules/ZineCover';
import ZineDraftStore from '../stores/ZineDraftStore';
import NavigationContextTypes from '../constants/NavigationContextTypes';
import PageControlsTypes from '../constants/PageControlsTypes';
import createStoreMixin from '../mixins/createStoreMixin';
import ZineActionCreators from '../actions/ZineActionCreators';
import ColorPicker from '../organisms/ColorPicker';
import UserStore from '../stores/UserStore';
import DocumentTitle from '../atoms/DocumentTitle';
import PureRenderMixin from '../mixins/PureRenderMixin';
import AppContext from '../AppContext';
import ZineStatus from '../constants/ZineStatus';

const NewZinePage = React.createClass({
  mixins: [ClassNameMixin, createStoreMixin(ZineDraftStore), PureRenderMixin],

  statics: {
    willTransitionTo(transition) {
      if (!UserStore.isAuthenticated()) {
        transition.redirect('about');
      }

      ZineActionCreators.destroyZineDraft();
    },

    willTransitionFrom() {
      ZineActionCreators.destroyZineDraft();
    }
  },

  getStateFromStores() {
    return {
      zine: ZineDraftStore.getActiveDraft()
    };
  },

  getNavigationContext() {
    return [NavigationContextTypes.ZINE, {
      isEditing: true
    }];
  },

  getPageControls() {
    return [PageControlsTypes.ZINE_EDIT];
  },

  getAppContext() {
    const [navigationContextType, navigationContextOptions] = this.getNavigationContext();
    const [pageControlsType, pageControlsOptions] = this.getPageControls();

    return {
      navigationContextType,
      navigationContextOptions,
      pageControlsType,
      pageControlsOptions
    };
  },

  componentDidMount() {
    ZineActionCreators.createNewZineDraft({
      backColor: ColorPicker.getRandomColor(),
      curator: UserStore.getMe().id,
      title: '',
      description: '',
      coverUrl: null,
      thumbnailUrl: null,
      status: ZineStatus.PUBLIC
    });
  },

  render() {
    var { zine } = this.state;

    return (
      <AppContext {...this.getAppContext()}>
        <DocumentTitle title={(zine && zine.title) || 'New Collection'}>
          <div className={this.getClassName()}>
            {zine &&
              <ZineCover zine={zine}
                         isEditing />
            }
          </div>
        </DocumentTitle>
      </AppContext>
    );
  }
});

export default NewZinePage;


/** WEBPACK FOOTER **
 ** ./pages/NewZinePage.jsx
 **/